<script>
import VAppLayout from "@/layouts/VAppLayout.vue";
import VReviewAdd from "@/modules/review/components/VReviewAdd.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VPaymentError from "@/components/ui/VPaymentError.vue";
import loader from "@/plugins/loader.plugin";

const QUERY_COUNT_LIMIT = 15

export default {
    name: "PaymentResultTab",
    components: {
        VContainer,
        VReviewAdd,
        VAppLayout,
        VPaymentError,
    },
    data() {
        return {
            checking: null,
            interval: null,
            intervalTimeMS: 4000,
            status: null,
            queryCounter: 0,
            addReview: false,
            orderNumber: '',
            paymentError: false,
            errorTimestamp: null,
            firstRequestTimestamp: null
        }
    },
    mounted() {
        this.checking = true
      if(this.checking) {
        loader.show();

        let order_id = this.$route.query.order_id;

        if(this.$route.query.instant_update) {
          this.fetchOrderStatus()
        }

        if(!order_id) {
          //get last order_id from local storage
          order_id = this.$store.getters['cartStore/getLastOrderId'];

          if(!order_id) {
            this.getOrderIdFromFingerprint();
          } else {
            this.processOrderStatus(order_id);
          }
        } else {
          this.processOrderStatus(order_id);
        }
      }
    },
    computed: {
        computedCompanyData: function () {
            return this.$store.getters['getCompanyData']
        },
        isSelfPickup() {
          return this.$store.getters['cartStore/getDeliveryMethod'] && this.$store.getters['cartStore/getDeliveryMethod'].self_pickup === 1;
        }
    },
    watch: {
        checking: function (val) {
            if (!val) clearInterval(this.interval)
        },
        queryCounter: function (val) {
            if (+val === +QUERY_COUNT_LIMIT) {
                this.handlePaymentError(this.firstRequestTimestamp);
            }
        }
    },
    methods: {
      showReviewForm() {
        console.log('showReviewForm');
        this.addReview = true
      },


      fetchOrderStatus() {
        if(!this.checking) {
          return
        }
        
        // Записуємо час першого запиту
        if (!this.firstRequestTimestamp) {
          this.firstRequestTimestamp = new Date().toLocaleString('pl-PL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        }
        
        this.$store.dispatch('cartStore/FETCH_IF_PAYED_ORDER_CHANGE_STATUS', this.$route.query.order_id)
            .then(resp => {
              if (resp && resp.status === 'error') {
                this.handlePaymentError();
              } else {
                this.processCompanyData(resp);
              }
            })
            .catch(error => {
              console.log('Error in fetchOrderStatus:', error);
            });
      },
      processCompanyData(resp) {
        if(!this.checking) {
          return
        }

        this.setLocaleData(resp);

        if (resp.order.status === "success") {
          this.status = resp.order.status
          this.checking = false
          this.orderNumber = resp.order.order_number


          this.setLocaleData(resp, true);

          this.$store.dispatch('cartStore/CLEAR_CART')
          this.$store.dispatch('cartStore/CLEAR_ORDERS')
        }
      },
      setLocaleData( resp, $hideLoader = false) {
        if (this.$store.getters['getCompanyName'] === null || this.$store.getters['getCompanyData'] === null) {
          let queryCn = resp.cn || null,
              queryT = resp.order.table_id || null;


          // initial loading
          if (queryCn !== null) {
            this.$store.dispatch('FETCH_AND_SET_COMPANY_NAME', queryCn).then(() => {
              this.$store.dispatch('FETCH_AND_SET_INITIAL_APP_DATA', queryT).then(() => {
                this.$store.dispatch('FETCH_AND_SET_TABLE_DATA', queryT).then(
                  () => {
                    if ($hideLoader) {
                      loader.hide()
                    }
                  }
                )
              })
            })
          }
        }  else if ($hideLoader) {
          loader.hide()
        }
      },
      processOrderStatus(order_id) {
        if (!this.firstRequestTimestamp) {
          this.firstRequestTimestamp = new Date().toLocaleString('pl-PL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        }


        
        this.interval = setInterval(() => {
          this.queryCounter++

          this.$store.dispatch('cartStore/FETCH_IF_PAYED_ORDER_CHANGE_STATUS', order_id)
              .then(resp => {
                if (resp && resp.status === 'error') {
                  this.handlePaymentError();
                } else {
                  this.processCompanyData(resp);
                }
              })
              .catch(error => {
                console.log('Error in processOrderStatus:', error);
                // this.handlePaymentError();
              });

        }, this.intervalTimeMS)
      },
      handlePaymentError(customTimestamp = null) {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        
        this.checking = false;
        this.paymentError = true;
        
        this.errorTimestamp = customTimestamp || new Date().toLocaleString('pl-PL', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });

        this.$store.dispatch('cartStore/CLEAR_CART')
        this.$store.dispatch('cartStore/CLEAR_ORDERS')

        loader.hide();
      },
      getOrderIdFromFingerprint() {

        this.$store.dispatch('cartStore/FETCH_ORDER_ID_FROM_FINGERPRINT')
            .then(resp => {
              if(resp) {
                this.processOrderStatus(resp);
              } else {
                console.log('Error: Order ID not received');
              }
            })
            .catch(error => {
              console.log('Error fetching Order ID:', error);
            });
      }
    }
}
</script>

<template>
    <VAppLayout>
        <!-- Payment Error Screen -->
        <VPaymentError 
            v-if="paymentError" 
            :timestamp="errorTimestamp"
        />
        
        <!-- Normal Content -->
        <VContainer v-else class="payment-result-container">
            <section class="payment-result" v-if="$store.getters['getIsModeQSR'] || $store.getters['getIsModeSOT'] || $store.getters['getIsModeHOT']">
              <div class="payment-result_logo">
                <img :src="computedCompanyData.locale.logo" :alt="`Logo of ${computedCompanyData.locale.name}`">
              </div>

              <div v-if="checking" class="payment-result_status">
                <div class="status-spinner" aria-hidden="true"></div>
                <h6 v-if="status === null" class="status-heading">
                  {{ $t('pages.paymentResult.checking') }}
                </h6>
                <p class="status-message">
                  {{ $t('pages.paymentResult.checkingStatus') }}
                </p>
              </div>

              <div v-if="!addReview && !checking && (status === 'success')" class="success-block">
                <div class="success-block_icon">
                  <img src="@/assets/img/ic_round-done.png" alt="" class="success-image">
                </div>
                <h6 class="status-heading">
                  {{ $t('pages.paymentResult.gratification') }}
                </h6>
                <p v-if="isSelfPickup" class="success-text">
                  {{ $t('pages.paymentResult.successCommentSelfPickup') }}
                </p>
                <p v-else class="success-text">
                  {{ $t('pages.paymentResult.successCommentDelivery') }}
                </p>
                <h3 class="success-order">{{ $t('pages.paymentResult.orderNumber') }}<br>#{{ orderNumber }}</h3>
                <button type="button"
                        class="success-block__cta"
                        @click="showReviewForm">
                  {{ $t('pages.paymentResult.review') }}
                </button>
              </div>

              <div v-if="addReview" class="payment-result_content">
                <VReviewAdd
                    :is-restaurant-logo-visible="false"/>
              </div>
            </section>
            <section class="payment-result" v-else>
                <div class="payment-result_logo">
                    <img :src="computedCompanyData.locale.logo" :alt="`Logo of ${computedCompanyData.locale.name}`">
                </div>

                <div
                    v-if="checking"
                    class="payment-result_status">
                    <div class="status-spinner" aria-hidden="true"></div>
                    <h6 v-if="status === null" class="status-heading">
                        {{ $t('pages.paymentResult.checking') }}
                    </h6>
                    <p class="status-message">
                        {{ $t('pages.paymentResult.checkingStatus') }}
                    </p>
                </div>
                <div
                    v-else-if="!checking && (status === 'success')"
                    class="payment-result_content">
                    <VReviewAdd
                        :is-restaurant-logo-visible="false"/>
                </div>
            </section>
        </VContainer>
    </VAppLayout>
</template>

<style lang="scss" scoped>

/* VContainer is a fixed height:100% box — content taller than the screen
   (success block + review button, or the review form) overflows it, and the
   layout's bottom-nav padding is bypassed past overflowing content, hiding the
   last button behind the dock with no way to scroll it out. Let the container
   grow with content instead: the --has-nav padding then lands after it and the
   page scrolls clear of the nav. */
.v-container.payment-result-container {
    height: auto;
    /* viewport units, not %: the document scrolls now, so ancestor heights are
       content-driven and a % min-height would resolve to nothing */
    min-height: 100vh;
    min-height: 100svh;
    display: flex;
    flex-direction: column;
}

.payment-result {
    /* top pad clears the status bar (viewport-fit=cover paints under it) */
    padding: calc(24px + var(--safe-top, 0px)) 0 24px;
    flex: 1 0 auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 32px;

    &_logo {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 64px;

        img {
            max-width: 160px;
            max-height: 100%;
            object-fit: contain;
        }
    }

    &_status {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        background: var(--surface-card);
        border-radius: var(--radius-3xl);
        box-shadow: var(--shadow-md);
        padding: 40px 24px;
        text-align: center;
    }

    &_content {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
    }

  .success-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    background: var(--surface-card);
    border-radius: var(--radius-3xl);
    box-shadow: var(--shadow-md);
    padding: 40px 24px;

    &_icon {
      width: 96px;
      height: 96px;
      border-radius: var(--radius-pill);
      background: var(--success-soft);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .success-image {
      width: 56px;
      height: 56px;
      object-fit: contain;
    }

    .success-text {
      color: var(--text-secondary);
      font-size: var(--text-base);
      line-height: 1.5;
      margin: 0;
    }
  }

  /* Same pill CTA as the favorites / empty-bill screens */
  .success-block__cta {
    margin-top: 6px;
    padding: 11px 22px;

    font-family: inherit;
    font-weight: var(--weight-bold);
    font-size: 14px;
    line-height: 1;

    border: none;
    border-radius: var(--radius-pill);
    background: var(--grad-brand);
    box-shadow: var(--shadow-brand);
    color: var(--color-on-primary);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
}

.status-heading {
  margin: 0;
  font-weight: var(--weight-black);
  font-size: var(--text-2xl);
  color: var(--text-primary);
}

.status-message {
  margin: 0;
  color: var(--text-secondary);
  font-size: var(--text-base);
  line-height: 1.5;
}

.success-order {
  margin: 0;
  color: var(--color-primary);
  font-weight: var(--weight-bold);
  font-size: var(--text-3xl);
  line-height: 1.3;
}

.status-spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid var(--color-primary-soft);
  border-top-color: var(--color-primary);
  animation: pr-spin 0.8s linear infinite;
}

@keyframes pr-spin {
  to { transform: rotate(360deg); }
}

</style>
